import { getCurrentStationId } from '@spx-portal/shared-utils';
import isNil from 'lodash/isNil';
import { initStorageDB } from 'Shared/utils/storageManager';

const INDEXED_DB_DB_NAME = 'workstation-dashboard-db';

export class DashboardDBManager {
  tableName: string;
  dbName: string;
  db: any;

  constructor(dbName: string, tableName = 'workstation-dashboard') {
    this.tableName = tableName;
    this.dbName = dbName;
    this.db = null;
  }

  init() {
    if (isNil(this.db)) {
      this.db = initStorageDB(this.tableName, this.dbName);
    }
  }

  async get(key: string | number) {
    try {
      const stationId = getCurrentStationId();
      const compositeKey = `${stationId}_${key}`;
      this.init();
      const data = await this.db[this.tableName].get(compositeKey) || {};
      return data.value;
    } catch (e) {
      console.error('[Storage Manager] get error: ', e);
      return undefined;
    }
  }

  async put(key: string | number, value: any) {
    try {
      const stationId = getCurrentStationId();
      const compositeKey = `${stationId}_${key}`;
      this.init();
      return await this.db[this.tableName].put({ key: compositeKey, value });
    } catch (e) {
      console.error('[Storage Manager] put error: ', e);
      return undefined;
    }
  }

  async clear() {
    try {
      this.init();
      return await this.db[this.tableName].clear();
    } catch (e) {
      console.error('[Storage Manager] clear error: ', e);
      return undefined;
    }
  }

  async delete(key: string) {
    try {
      const stationId = getCurrentStationId();
      const compositeKey = `${stationId}_${key}`;
      this.init();
      return await this.db[this.tableName].delete(compositeKey);
    } catch (e) {
      console.error('[Storage Manager] delete error: ', e);
      return undefined;
    }
  }
}

export function getDashboardDBManager(tableName: string) {
  return new DashboardDBManager(INDEXED_DB_DB_NAME, tableName);
}

export const dashboardDBManager = new DashboardDBManager(INDEXED_DB_DB_NAME, 'workstation-dashboard');
